import { render, staticRenderFns } from "./VueEditorLiveTemplate.vue?vue&type=template&id=63791a5a"
import script from "./VueEditorLiveTemplate.vue?vue&type=script&lang=js"
export * from "./VueEditorLiveTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports